<template>
  <first-page>
    <forgot-password-form/>
  </first-page>
</template>

<script>
import FirstPage from "@/components/pages/FirstPage";
import ForgotPasswordForm from "@/components/login/ForgotPasswordForm";

export default {
  name: "ForgotPasswordPage",
  components: {ForgotPasswordForm, FirstPage}
}
</script>

<style scoped>

</style>
